<template>
  <div class="map">
    <div id="container"></div>
    <div class="diagram">
      <div>
        <p>--</p>
        <span>线路</span>
      </div>
      <div>
        <img src="@/assets/images/index/icon-qiaotip@2x.png">
        <span>桥梁</span>
      </div>
      <div>
        <img src="@/assets/images/index/icon-gantip@2x.png">
        <span>传感器</span>
      </div>
    </div>
    <Tree
      @lineBridgeDevice="lineBridgeDevice($event)"
      @alarmsMsg="alarmsMsg"
    />
    <a-modal
      :visible="previewVisible"
      :footer="null"
      @cancel="handleCancel"
    >
      <img
        alt="example"
        style="width: 100%"
        :src="previewImage"
      />
    </a-modal>
  </div>
</template>

<script>
// @ is an alias to /src
import AMapLoader from '@amap/amap-jsapi-loader';
import _global from '@/utils/global'
import Tree from "@/components/home/tree.vue";
import qiaoliang from '../../assets/images/index/icon-qiaotip@2x.png';
// import shebei from '../../assets/images/index/icon-gantip@2x.png';

export default {
  name: "map",
  components: {
    Tree,
  },
  data() {
    return {
      baseURL: _global.baseURL,
      visible: false,
      modalStyle: {
        left: 0,
        top: 0
      },
      // AMap: '',
      // map: '',
      driving: '',
      coordinate: [],
      previewVisible: false,
      previewImage: ''
    }
  },
  props: ['theme'],
  mounted() {
    // this.initMap()
  },
  methods: {
    alarmsMsg(e) {  //大屏展示  报警信息联动
      // console.log(e);
      this.$emit('alarmsInfo', e)
    },
    lineBridgeDevice(e) {
      // console.log(e);
      var coordinate = []
      var lineData = e.lineData
      for (let i = 0; i < lineData.length; i++) {
        if (lineData[i].coordinateString) {
          coordinate.push(lineData[i].coordinateString.split('-'))
          lineData[i].pathList = []
          lineData[i].path = []
          for (let j = 0; j < coordinate[i].length; j++) {
            lineData[i].path.push([])
            lineData[i].path[j][0] = coordinate[i][j].split(',')[0]
            lineData[i].path[j][1] = coordinate[i][j].split(',')[1]
            lineData[i].pathList.push({ longitude: '', latitude: '' })
            lineData[i].pathList[j].longitude = coordinate[i][j].split(',')[0]
            lineData[i].pathList[j].latitude = coordinate[i][j].split(',')[1]
          }
        }
      }
      this.initMap(e)
    },
    initMap(e) {
      console.log(e)
      var _this = this
      AMapLoader.load({
        "key": "6962db9cdf50008a6f119d9684f08c56", // 申请好的Web端开发者Key，首次调用 load 时必填
        "version": "",       // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
        "plugins": ['AMap.Scale', 'AMap.ToolBar', 'AMap.Polyline', 'AMap.Marker', 'AMap.InfoWindow', 'AMap.MarkerClusterer'],
        "Loca": {                // 是否加载 Loca， 缺省不加载
          "version": ''  // Loca 版本，缺省 1.3.2
        },
      }).then((AMap) => {
        const colors = ['#DC143C', '#5F9EA0', '#00BFFF', '#C71585', '#6495ED',
          '#008B8B', '#FFFF00', '#FFD700', '#FFDEAD', '#FF4500',
          '#FF8C00', '#8B4513', '#FFF5EE', '#FF7F50', '#FF6347']

        if (this.theme == 'dark') {
          var mapStyle = 'amap://styles/grey'
        } else {
          var mapStyle = 'amap://styles/012c7a0227cae9391a222ec374fbeab7'
        }
        _this.map = new AMap.Map('container', {
          mapStyle: mapStyle, // 换地图样式风格
          center: [116.397559, 39.89621],
          zoom: 5
        })
        var lineData = e.lineData
        for (let i = 0; i < lineData.length; i++) {
          const nowItem = lineData[i]
          createPolyline(i, nowItem)

          const item_path = lineData[i].pathList
          const now_length = item_path.length
          const item_start_path = item_path[0]
          const item_end_path = item_path[now_length - 1]
          if (_this.theme != 'dark') {
            createMarkerOne(item_start_path, '起点', nowItem)
            createMarkerOne(item_end_path, '终点', nowItem)
          }
        }
        // 缩放地图到合适的视野级别
        // _this.map.setFitView()
        if (_this.theme == 'dark') {
          //大屏
          pointAggregation(e.bridgeData)
        } else {
          // 首页
          createMarkerNormal(e.bridgeData) // 桥梁marker
        }

        function createPolyline(i, nowItem) {
          var polyline = polyline + i
          var num = i % 15
          polyline = new AMap.Polyline({
            path: nowItem.path,            // 设置线覆盖物路径
            strokeColor: colors[num],   // 线颜色
            strokeOpacity: 0.6,         // 线透明度
            strokeWeight: 6,          // 线宽
            strokeStyle: 'solid',     // 线样式
            showDir: true,            //显示箭头
            lineJoin: 'round'         //折线拐点的绘制样式
          })
          if (_this.theme != 'dark') {
            polyline.setMap(_this.map)
          }

          var showInfo = showInfo + i
          var infoWindow = infoWindow + i
          showInfo = function(e) {
            // console.log(e)
            infoWindow = new AMap.InfoWindow({
              content: '名称：' + nowItem.lineName + '</br>编号：' + nowItem.lineNumber + '</br>里程：' + nowItem.mileage + 'km</br>桥梁数：' + nowItem.bridgeTotal + '</br>说明信息：' + nowItem.lineDescribe
            })
            infoWindow.open(_this.map, e.lnglat)
          }
          polyline.on('mouseover', function(e) {
            // console.log(e, index)
            polyline.setOptions({
              strokeOpacity: 1,
              strokeWeight: 8
            })
            showInfo(e)
          })
          polyline.on('mouseout', function(e) {
            // console.log(e, index)
            polyline.setOptions({
              strokeOpacity: 0.6,
              strokeWeight: 6
            })
            infoWindow.close()
          })
          return polyline
        }
        // 起点 或 终点 marker(单个)
        function createMarkerOne(item, type, nowItem) {
          // console.log(item)
          let iconUrl = '', siteName = ''
          if (type === '起点') {
            iconUrl = 'https://webapi.amap.com/theme/v1.3/markers/n/start.png'
            siteName = '起点'
          } else if (type === '终点') {
            iconUrl = 'https://webapi.amap.com/theme/v1.3/markers/n/end.png'
            siteName = '终点'
          }
          // -------- 站点-----------
          const oneMarker = new AMap.Marker({
            icon: iconUrl,
            position: new AMap.LngLat(item.longitude, item.latitude),
            offset: new AMap.Pixel(-9, -32),
            map: _this.map
          })
          // 给 Text 带上自定义私货
          // 监听地图- Text 的 点击事件
          const clickHandler1 = function(e) {
            // log.success("carText模拟触发了地图click事件!");
            new AMap.InfoWindow({
              content: '名称：' + nowItem.lineName + '</br>编号：' + nowItem.lineNumber + '</br>里程：' + nowItem.mileage + '</br>桥梁数：' + nowItem.bridgeTotal + '</br>说明信息：' + nowItem.lineDescribe
            }).open(_this.map, e.lnglat)
          }
          oneMarker.on('click', clickHandler1)
          oneMarker.setMap(_this.map)
          //-------siteText-------
          // label默认蓝框白底左上角显示，样式className为：amap-marker-label
          // const siteText = new AMap.Text({
          //   offset: new AMap.Pixel(0, -50),  //设置文本标注偏移量
          //   text: nowItem.name,
          //   position: new AMap.LngLat(item.longitude, item.latitude), // 这里特殊 本数据结构， startLatitude
          //   map: _this.map
          // })
          // siteText.lisaSiteInfo = item
          // siteText.on('click', clickHandler1)
          // siteText.setMap(_this.map)
          return oneMarker
        }
        // 桥梁marker
        function createMarkerNormal(now_arr) {
          // console.log('now_arr', now_arr)
          const middleMarkers = []
          now_arr.forEach((item, index) => {
            // 给 Text 带上自定义私货
            // 监听地图- Text 的 点击事件
            const clickHandler1 = function(e) {
              // console.log(e)
              var content = []
              content.push("<p class=''>编号：" + item.bridgeNumber + "</p>")
              content.push("<p class=''>名称：" + item.bridgeName + "</p>")
              content.push("<p class=''>跨度：" + item.span + "m</p>")
              content.push("<p class=''>简介：" + item.introduction + "</p>")
              content.push("<a href=\"" + _this.baseURL + item.bridgeDiagram + "\" target=\"_blank\">桥梁简图</a>")
              content.push("<a href=\"" + _this.baseURL + item.bridgeActualDrawing + "\" target=\"_blank\" style=\"margin-left: 20px\">桥梁实景图</a>")
              // content.push("<p class=\"preview\" onclick=\"" + _this.imageShow(_this.baseURL + item.bridgeDiagram) + "\" >桥梁简图</p>")
              var infoWin = new AMap.InfoWindow({
                content: content.join("")
                // content: '名称：' + item.bridgeName + '</br>编号：' + item.bridgeNumber + '</br>跨度：' + item.span + 'm</br>简介：' + item.introduction + '</br>桥梁简图：' + _this.baseURL + item.bridgeDiagram + '</br>桥梁实景图：' + _this.baseURL + item.bridgeActualDrawing
              })
              infoWin.open(_this.map, e.lnglat)
            }
            if (_this.theme == 'dark') {
              // 创建纯文本标记
              var text = new AMap.Text({
                text: item.totalAlarm || '0',
                anchor: 'center', // 设置文本标记锚点
                cursor: 'pointer',
                style: {
                  'width': '32px',
                  'height': '32px',
                  'border-width': 0,
                  'text-align': 'center',
                  'font-size': '14px',
                  'line-height': '26px',
                  'color': '#fff',
                  'border-radius': '50%',
                  'background-color': 'rgba(6,152,206,.6)',
                },
                position: new AMap.LngLat(item.longitude, item.latitude),
              });
              // text.on('click', clickHandler1)
              // text.setMap(_this.map);
              // middleMarkers.push(text)
            } else {
              // 创建一个 Icon
              const siteIcon = new AMap.Icon({
                // 图标尺寸
                size: new AMap.Size(28, 28),
                // 图标的取图地址
                // image: '//a.amap.com/jsapi_demos/static/demo-center/icons/dir-via-marker.png',
                image: qiaoliang,
                // 图标所用图片大小
                imageSize: new AMap.Size(28, 28),
                // 图标取图偏移量
                imageOffset: new AMap.Pixel(0, 0)
              });
              const siteMarker = new AMap.Marker({
                icon: siteIcon,
                position: new AMap.LngLat(item.longitude, item.latitude),
                offset: new AMap.Pixel(-12, -32),
                map: _this.map
              })
              siteMarker.on('click', clickHandler1)
              siteMarker.setMap(_this.map)
              middleMarkers.push(siteMarker)
            }
            //-------siteText-------
            // label默认蓝框白底左上角显示，样式className为：amap-marker-label
            // const siteText = new AMap.Text({
            //   offset: new AMap.Pixel(0, -50),  //设置文本标注偏移量
            //   text: item.bridgeName,
            //   position: new AMap.LngLat(item.longitude, item.latitude),
            //   map: _this.map
            // })
            // siteText.on('click', clickHandler1)
            // siteText.setMap(_this.map)
            // middleMarkers.push(siteText)
          })
          // _this.map.setFitView()
          return middleMarkers
        }
        //点聚合
        function pointAggregation(now_arr) {
          var points = [], alarmMarkers = [], cluster
          for (let i = 0; i < e.bridgeData.length; i++) {
            const el = e.bridgeData[i];
            points.push({
              lnglat: [el.longitude, el.latitude]
            })
          }
          console.log(points)
          const middleMarkers = []
          now_arr.forEach((item, index) => {
            // 给 Text 带上自定义私货
            // 监听地图- Text 的 点击事件
            const clickHandler1 = function(e) {
              // console.log(e)
              var content = []
              content.push("<p class=''>编号：" + item.bridgeNumber + "</p>")
              content.push("<p class=''>名称：" + item.bridgeName + "</p>")
              content.push("<p class=''>跨度：" + item.span + "m</p>")
              content.push("<p class=''>简介：" + item.introduction + "</p>")
              content.push("<p class=''>预警数量：" + item.totalAlarm + "</p>")
              content.push("<a href=\"" + _this.baseURL + item.bridgeDiagram + "\" target=\"_blank\">桥梁简图</a>")
              content.push("<a href=\"" + _this.baseURL + item.bridgeActualDrawing + "\" target=\"_blank\" style=\"margin-left: 20px\">桥梁实景图</a>")
              new AMap.InfoWindow({
                content: content.join("")
                // content: '名称：' + item.bridgeName + '</br>编号：' + item.bridgeNumber + '</br>跨度：' + item.span + 'm</br>简介：' + item.introduction + '</br>桥梁简图：' + _this.baseURL + item.bridgeDiagram + '</br>桥梁实景图：' + _this.baseURL + item.bridgeActualDrawing
              }).open(_this.map, e.lnglat)
            }
            // 创建一个 Icon
            const siteIcon = new AMap.Icon({
              // 图标尺寸
              size: new AMap.Size(28, 28),
              // 图标的取图地址
              // image: '//a.amap.com/jsapi_demos/static/demo-center/icons/dir-via-marker.png',
              image: qiaoliang,
              // 图标所用图片大小
              imageSize: new AMap.Size(28, 28),
              // 图标取图偏移量
              imageOffset: new AMap.Pixel(0, 0)
            });
            const siteMarker = new AMap.Marker({
              icon: siteIcon,
              position: new AMap.LngLat(item.longitude, item.latitude),
              offset: new AMap.Pixel(-12, -32),
              map: _this.map
            })
            siteMarker.on('click', clickHandler1)
            siteMarker.setMap(_this.map)
            middleMarkers.push(siteMarker)
          })

          // for (var i = 0; i < points.length; i += 1) {
          //   alarmMarkers.push(new AMap.Marker({
          //     position: points[i]['lnglat'],
          //     content: '<div style="background-color: hsla(180, 100%, 50%, 0.7); height: 24px; width: 24px; border: 1px solid hsl(180, 100%, 40%); border-radius: 12px; box-shadow: hsl(180, 100%, 50%) 0px 0px 1px;"></div>',
          //     offset: new AMap.Pixel(-15, -15)
          //   }))
          // }

          var count = middleMarkers.length;
          var _renderClusterMarker = function(context) {
            var factor = Math.pow(context.count / count, 1 / 18);
            var div = document.createElement('div');
            var Hue = 180 - factor * 180;
            var bgColor = 'rgba(6,152,206,.6)';
            var fontColor = '#fff';
            var borderColor = 'rgba(6,152,206,.6)';
            var shadowColor = 'rgba(6,152,206,.6)';
            div.style.backgroundColor = bgColor;
            var size = Math.round(30 + Math.pow(context.count / count, 1 / 5) * 20);
            div.style.width = div.style.height = size + 'px';
            div.style.border = 'solid 1px ' + borderColor;
            div.style.borderRadius = size / 2 + 'px';
            div.style.boxShadow = '0 0 1px ' + shadowColor;
            div.innerHTML = context.count;
            div.style.lineHeight = size + 'px';
            div.style.color = fontColor;
            div.style.fontSize = '14px';
            div.style.textAlign = 'center';
            context.marker.setOffset(new AMap.Pixel(-size / 2, -size / 2));
            context.marker.setContent(div)
          };
          cluster = new AMap.MarkerClusterer(_this.map, middleMarkers, {
            gridSize: 80,
            averageCenter: true,
            renderClusterMarker: _renderClusterMarker
          });
        }
      }).catch(res => {
        console.log(res)
      });
    },
    imageShow(url) {
      this.previewImage = url
      this.previewVisible = true
    },
    handleCancel() {
      this.previewVisible = false
    }
  }
}

</script>

<style scoped>
.map {
  position: relative;
}
#container {
  height: 80vh;
  margin: 20px 30px;
  border: 2px solid #ffffff;
  border-radius: 12px;
  box-shadow: 0px 4px 20px 0px rgba(0, 0, 0, 0.1);
}
.diagram {
  display: flex;
  justify-content: center;
  flex-direction: column;
  position: absolute;
  right: 400px;
  top: 20px;
  width: 100px;
  height: 78px;
  padding: 10px;
  font-size: 12px;
  line-height: 1.8;
  color: #666;
  font-family: PingFang SC;
  background: rgb(255, 255, 255);
  border-radius: 6px;
}
.diagram div {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.diagram img {
  width: 12px;
}
.diagram span {
  margin-left: 10px;
}
.tree {
  position: absolute;
  top: 20px;
  right: 50px;
  min-width: 270px;
  height: 440px;
}
.modal {
  position: absolute;
  width: 238px;
  padding: 12px;
  text-align: left;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0px 4px 20px 0px rgba(0, 0, 0, 0.1);
}
.modal .ant-col-10 {
  font-size: 12px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #888;
  line-height: 18px;
}
.modal .ant-col-14 {
  font-size: 12px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #222;
  line-height: 18px;
}
.map :deep .tree {
  height: 400px;
  overflow-y: scroll;
}
.map :deep .tree::-webkit-scrollbar {
  display: none;
}
</style>
